import { w } from 'windstitch';

export const Wrapper = w.header(
  'flex items-center justify-center md:justify-between w-full px-4 lg:px-8',
);

export const BtnBox = w.div(
  'gap-4 hidden md:flex',
);

export const Btn = w.button(
  'hover:text-[var(--azul)] text-base lg:text-xl',
);